import { Component, OnInit } from '@angular/core';
import { LoaderService } from '../_services/loader.service';
import { TranslateService } from '@ngx-translate/core';
import { ErrorCode } from '../_models/error-code';
@Component({
  standalone: false,
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit {
  loading: boolean; message: string;
  style = { width: 'min(90vw, 500px)', minHeight: '200px' };
  private serverErrorMessage = '';
  constructor(private loadingService: LoaderService, private translate: TranslateService) {
    this.loadingService.isLoading.subscribe((res) => {
      this.loading = res;
    });

  }

  ngOnInit(): void {
    this.loadingService.serverErrorMessage.subscribe((msg) => {
      this.serverErrorMessage = msg;
    });
    this.loadingService.commonerrorText.subscribe((res) => {
      console.debug('loading service common error text', res);
      switch (res) {
        case ErrorCode.Forbidden:
          this.message = this.translate.instant('errorMsg');
          break;
        case ErrorCode.InvalidCaptcha:
          this.message = this.translate.instant('invalidCaptchaErrorMsg');
          break;
        case ErrorCode.CaptchaBrowserError:
          // this.message = this.translate.instant('captchaBrowserErrorMsg');
          this.message = this.translate.instant('invalidCaptchaErrorMsg');
          break;
        case ErrorCode.RemoteFileTooLarge:
          this.message = this.serverErrorMessage || this.translate.instant('fileTooLargeErrorMsg');
          break;
        case ErrorCode.TotalAttachmentSizeExceeded:
          this.message = this.serverErrorMessage || this.translate.instant('totalAttachmentSizeExceededErrorMsg');
          break;
        default:
          this.message = this.translate.instant('commonErrorMsg');
      }
    });

  }

  closeDialogbox() {
    this.loadingService.hide();
  }

}

